import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Test from "./Test";

const queryClient = new QueryClient();
const testRootNode = document.getElementById('test-root');

if (testRootNode) {
    const testId = testRootNode.dataset.id;

    const quizRoot = ReactDOM.createRoot(testRootNode);
    quizRoot.render(
        <QueryClientProvider client={queryClient}>
            <Test testId={testId} />
        </QueryClientProvider>
    );

}